import React from "react";
import { Modal, Button } from "react-bootstrap";

const VARIANT_TITLES = {
  warning: "Advertencia",
  danger: "Error",
  success: "Aviso",
  info: "Aviso",
};

const VARIANT_ICONS = {
  warning: "fa-exclamation-triangle text-warning",
  danger: "fa-times-circle text-danger",
  success: "fa-check-circle text-success",
  info: "fa-info-circle text-primary",
};

export default function NotificationModal({
  show,
  onHide,
  message,
  title,
  variant = "warning",
  acceptLabel = "Aceptar",
}) {
  const resolvedTitle = title || VARIANT_TITLES[variant] || "Aviso";
  const iconClass = VARIANT_ICONS[variant] || VARIANT_ICONS.info;

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>
          <i className={`fa ${iconClass} mr-2`}></i>
          {resolvedTitle}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ fontSize: "14px" }}>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant={variant === "danger" ? "danger" : "primary"} onClick={onHide}>
          {acceptLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
